/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from 'react';
// import Catalogue from './components/Catalogue';
import LeftSidePage from './components/LeftSidePage';
import RightSidePage from './components/RightSidePage';

function EspaceB2b() {
  return (
    <div className="row" style={{ marginTop: '65px' }}>
      <div className="col-6">
        <LeftSidePage />
      </div>
      <div className="col-6">
        <RightSidePage />

        {/* <Catalogue /> */}
      </div>
    </div>
  );
}

export default EspaceB2b;
